"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultWorkingWeek = exports.maxMeetingSignupDaysOptions = exports.signupGapHoursOptions = exports.RegularWeekday = exports.RegularSchedule = void 0;
var enums_1 = require("./enums");
/** Регулярное расписание пользователя */
var RegularSchedule = /** @class */function () {
  function RegularSchedule(values) {
    if (values === void 0) {
      values = {};
    }
    /** Время доступности по дням недели */
    this.weekdays = [];
    this.timezone = values.timezone || null;
    this.signup_gap_hours = values.signup_gap_hours || null;
    this.max_meeting_signup_days = values.max_meeting_signup_days || null;
    var weekdaysNums = Object.keys(enums_1.WeekdaysEnum).filter(function (k) {
      return typeof enums_1.WeekdaysEnum[k] === 'string';
    });
    var _loop_1 = function (weekdayNum) {
      var weekday = (values.weekdays || []).find(function (w) {
        return w.weekday === +weekdayNum;
      });
      var regularWeekday = new RegularWeekday(__assign({
        weekday: +weekdayNum
      }, weekday));
      this_1.weekdays.push(regularWeekday);
    };
    var this_1 = this;
    for (var _i = 0, weekdaysNums_1 = weekdaysNums; _i < weekdaysNums_1.length; _i++) {
      var weekdayNum = weekdaysNums_1[_i];
      _loop_1(weekdayNum);
    }
  }
  return RegularSchedule;
}();
exports.RegularSchedule = RegularSchedule;
var RegularWeekday = /** @class */function () {
  function RegularWeekday(values) {
    if (values === void 0) {
      values = {};
    }
    this.weekday = values.weekday || enums_1.WeekdaysEnum.sunday;
    this.enabled = !!values.enabled;
    this.hours = values.hours || [];
  }
  return RegularWeekday;
}();
exports.RegularWeekday = RegularWeekday;
exports.signupGapHoursOptions = [{
  title: '1 hour',
  value: 1
}, {
  title: '2 hours',
  value: 2
}, {
  title: '3 hours',
  value: 3
}, {
  title: '4 hours',
  value: 4
}, {
  title: '5 hours',
  value: 5
}, {
  title: '6 hours',
  value: 6
}, {
  title: '12 hours',
  value: 12
}, {
  title: '24 hours',
  value: 24
}, {
  title: '48 hours',
  value: 48
}, {
  title: '72 hours',
  value: 72
}];
exports.maxMeetingSignupDaysOptions = [{
  title: '1 week',
  value: 7
}, {
  title: '2 weeks',
  value: 14
}, {
  title: '3 weeks',
  value: 21
}, {
  title: '4 weeks',
  value: 28
}];
exports.defaultWorkingWeek = [new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.sunday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.monday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.tuesday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.wednesday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.thursday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.friday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
}), new RegularWeekday({
  weekday: enums_1.WeekdaysEnum.saturday,
  enabled: false,
  hours: [{
    begin_hour_at: 10,
    end_hour_at: 19
  }]
})];
